import { type FunctionComponent, useState } from 'react';

import { PractitionerIntroVideoModal } from 'components/PractitionerIntroVideoModal';

import { useProfileHeroImage } from 'hooks';

import { type ArtistT, E_FILE, P_API_ASSETS } from 'utils';

import './style.scss';

type PropsT = {
  artist: ArtistT;
  checked: boolean;
  onSwitch: () => void;
};

const ArtistRow: FunctionComponent<PropsT> = ({
  artist,
  checked,
  onSwitch,
}) => {
  const [showVideo, setShowVideo] = useState(false);

  const { data: heroImage } = useProfileHeroImage(artist.id ?? '');
  const avatarUrl = heroImage
    ? `${P_API_ASSETS}/${heroImage.id}${E_FILE}?s=360`
    : artist.user.avatarUrl;

  return (
    <>
      <div
        onClick={() => {
          if (artist.videoUrl) setShowVideo(true);
        }}
        role="presentation"
        styleName={artist.videoUrl ? 'row withVideo' : 'row'}
      >
        {avatarUrl
          ? <img alt="Artist avatar" src={avatarUrl} styleName="avatar" />
          : <div styleName="avatar">?</div>}
        <div styleName="nameAndSpecialization">
          <div styleName="name">
            {artist.displayName ?? `${artist.user.firstName} ${artist.user.lastName}`}
          </div>
          {artist.specialization
            ? <div styleName="specialization">{artist.specialization}</div>
            : null}
        </div>
        <div
          aria-label={checked ? 'Deselect artist' : 'Select artist'}
          onClick={(e) => {
            e.stopPropagation();
            onSwitch();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.stopPropagation();
              onSwitch();
            }
          }}
          role="button"
          styleName={checked ? 'indicator checked' : 'indicator'}
          tabIndex={0}
        />
      </div>
      {showVideo ? (
        <PractitionerIntroVideoModal
          artist={artist}
          onClose={() => {
            setShowVideo(false);
          }}
        />
      ) : null}
    </>
  );
};

export default ArtistRow;
